export function formatRequestUser(requestUser) {
    return `#${requestUser.user.id} ${requestUser.user.name} - ${requestUser.description || '???'}`;
}
